export const infoBribeByNftAbi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "nftid",
        type: "uint256",
      },
    ],
    name: "infoBribeByNftId",
    outputs: [
      {
        components: [
          {
            internalType: "address[3]",
            name: "A",
            type: "address[3]",
          },
          {
            internalType: "uint256",
            name: "N",
            type: "uint256",
          },
        ],
        internalType: "struct Equalens.BA2[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const
